import React, {FC, useEffect} from 'react';

import BackButton from '../../../../../components/BackButton/BackButton';
import {ArticlePageLayout} from '../../../../../components/DataDisplay';
import {ContentWrapper, MaxWidthContainer} from '../../../../../components/Layout';
import Container from '../../../../../components/Layout/Container/Container';
import * as localizationKeys from '../../../../../consts/localization/localizationKeys';
import useDocumentTitle from '../../../../../hooks/useDocumentTitle';
import analyticsService from '../../../../../services/analyticsService';
import connectivityService from '../../../../../services/device/connectivityService';
import {getLocalizedStrings} from '../../../../../services/localization/localizationService';

interface IProps {
    onClose: () => void;
    onNextClick?: () => void;
}

const FWUFirstStep: FC<IProps> = ({onClose, onNextClick}) => {
    const localizedStrings = getLocalizedStrings();
    const isBle = connectivityService.isBle();

    useDocumentTitle(localizedStrings[localizationKeys.ACCESSIBILITY_FEW_MORE_STEPS_PAGE_TITLE]);

    useEffect(() => {
        analyticsService.pushCompletingYourFirmwareUpgrade();
    }, []);

    return (
        <ContentWrapper>
            <MaxWidthContainer>
                {!isBle && (
                    <Container className='left-0 transform-none' isFloatHeight>
                        <BackButton
                            className='left-8 top-0 md:left-[60px]'
                            ariaLabel={
                                localizedStrings[
                                    localizationKeys.FWU_ADDITIONAL_STEPS_GUIDE_BTN_BACK_TO_ABOUT_DEVICE_ARIA_LABEL
                                ]
                            }
                            onClick={onClose}
                        />
                    </Container>
                )}
                <ArticlePageLayout
                    titleKey={localizationKeys.IQOS_DUO_FIRST_STEP_TITLE}
                    descriptionKey={localizationKeys.IQOS_DUO_FIRST_STEP_DESCRIPTION}
                    buttonPrimary={{
                        onClick: onNextClick,
                        textKey: localizationKeys.IQOS_DUO_FIRST_STEP_BUTTON_TEXT,
                    }}
                />
            </MaxWidthContainer>
        </ContentWrapper>
    );
};

export default FWUFirstStep;
